import React from 'react';
import * as Icons from "react-icons/fa";
import '../../components/styles.css';

export default function HowItWorks() {
    return (
      <div className='container-content-services'
        style={{
          backgroundColor:'gray',
          color:'black',
          border:'20px',
          padding:'20px',
		  	}}
		  >
        <div classNAme='main-content-box-1'  align='center'>
          <p-lg>How It Works  </p-lg>
        </div>
        <div className='main-content-box-2'  align='left'>
          <p> <br></br>
            Affiliate marketing involves a merchant (the company selling the product) and a digital agent (the 
individual or business promoting the product). Affiliates promote the partner’s products or services 
through various channels such as websites, blogs, social media, or email marketing. The approach is 
to keep it simple by creating clear, easy-to-read templates and making marketing campaigns as non
intrusive as possible.
          </p>
        </div>
        <div className='main-content-box-3' align='center' >
              <p></p>
        </div>
      </div>
    )
  };

